module.exports = __webpack_public_path__ + "media/images/pages/img_cover_left_06-5f6055620cb389ab4530536295b35a01.jpg";